mainBrandLib = (function ($) {
    return {

        fakeClick: function (event, anchorObj) {
           
            if (anchorObj.click) {
                anchorObj.click();
            } else if (document.createEvent) {
                if (event.target !== anchorObj) {
                    var evt = document.createEvent("MouseEvents");
                    evt.initMouseEvent("click", true, true, window,
                        0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    var allowDefault = anchorObj.dispatchEvent(evt);
                }
            }
        },

        newsletterSubmit: function (frm) {
            $(frm).find('.error').hide();
            var isValid = $("#NewsletterEmail").valid();
            var errMessate = $("#NewsletterEmail").data('val-regex');
            if (isValid) {
                $.post(frm.action, { NewsletterEmail: $("#NewsletterEmail").val() }, function (res) {
                    if (res.status === "ok") {
                        $(frm).hide().next('.success').show();
                    }
                    else {
                        $(frm).find('.error').show().text(res.message);
                    }
                });
            }
            else {
                $(frm).find('.error').show().text(errMessate);
            }

            return false;
        },

        initAutoComplete: function (elId) {
            var url = $(elId).data('url');

            $(elId).typeahead({
                hint: true,
                highlight: true,
                minLength: 1
            },
                {
                    name: 'states',
                    display: 'Name',
                    limit: 9,
                    source: function (query, process, processAsync) {
                        return $.post(url, { key: query }, function (res) {
                            return processAsync(res);
                        });
                    },
                    templates: {
                        suggestion: function (item) {
                            var resTpl = '<div>'
                                + '<span>' + item.Name + '</span>'
                                //+ '<img src="' + item.Image + '">'
                                + '</div>';
                            return resTpl;
                        }
                    }
                });

            $(elId).bind('typeahead:select', function (ev, item) {
                location.href = item.Url;
                return false;
            });
        },

        removeClass: function (elem, bgWhite) {
            elem.className = elem.className.replace(/(?:^|\s)bgWhite(?!\S)/g, '');
        },

        mapsSelector: function (latitude, longitude) {
            var q = "daddr=" + latitude + "," + longitude + "&amp;ll=";
            /* if we're on iOS, open in Apple Maps */
            if (navigator.platform.indexOf("iPhone") !== -1 ||
                navigator.platform.indexOf("iPad") !== -1 ||
                navigator.platform.indexOf("iPod") !== -1) {

                window.open("maps://maps.google.com/maps/dir/?" + q);
            }
            else { /* else use Google */
                window.open("https://maps.google.com/maps/dir/?" + q);
            }
        },

        init: function () {
            var self = this;
            this.initAutoComplete("#SearchInput");

            var elem = document.getElementById('SearchInput');
            if (elem) {
                elem.addEventListener('focus', function () {
                    if (this.value === '') {
                        this.className += " bgWhite";
                    }
                });

                elem.addEventListener('blur', function () {
                    if (this.value === '') {
                        self.removeClass(this, "bgWhite");
                    }
                });
            }

            $("a#btn-call-store").on('click', function (event) {});

            $("a#btn-map-store").on('click', function (event) {
                event.preventDefault();
                var latitude = $(this).data("latitude");
                var longitude = $(this).data("longitude");
                self.mapsSelector(latitude, longitude);
            });

            $("a.menu-item-link").on('click', function (event) {
                var href = decodeURI($(this).attr("href"));
                href = href.slice(href.indexOf("#")+1, href.length);
                console.log(href);
                var target = $("a[name='" + href + "']")[0];
                if (target) {
                    self.fakeClick(event, target);
                }
                
            });

            $(document).ready(function () {
                console.log(document.location.href);
                var href = decodeURI(document.location.href);
                href = href.slice(href.indexOf("#") + 1, href.length);
                var target = $("a[name='" + href + "']")[0];
                if (target) {
                    self.fakeClick(event, target);
                }
            });
        }
    };
})(jQuery);
